import { render, staticRenderFns } from "./AppointLearnManager.vue?vue&type=template&id=3508987e&scoped=true"
import script from "./AppointLearnManager.vue?vue&type=script&lang=js"
export * from "./AppointLearnManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3508987e",
  null
  
)

export default component.exports